import React from 'react';
import { useNotification } from '@adsk/bim360-matrix-react-notification-manager/es/helpers/context';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import AnchorButton from '@adsk/bim360-matrix-react-anchor-button';
import {
  NotificationTypes,
  NotificationLevels
} from '@adsk/bim360-matrix-react-notification-manager';
import { MDText } from 'i18n-react';
import formatRfiName from '../formatRfiName';

function useRfiNotifications() {
  const { showNotification } = useNotification();
  const { T } = useLocale(({ locale }) => new MDText(require(`../../i18n/${locale}.json`)));

  const handleView = deeplinkUrl => () => {
    window.open(deeplinkUrl);
  };

  const showSuccessNotification = (entity, deepLinkUrl) => {
    showNotification({
      type: NotificationTypes.TOAST,
      level: NotificationLevels.SUCCESS,
      message: T.translate('CREATE_SUCCESS', {
        name: <AnchorButton onClick={handleView(deepLinkUrl)}>{formatRfiName(entity)}</AnchorButton>
      })
    });
  };

  const showErrorNotification = () => {
    showNotification({
      type: NotificationTypes.SNACKBAR,
      level: NotificationLevels.ERROR,
      message: T.translate('CREATE_FAILED')
    });
  };

  return { showSuccessNotification, showErrorNotification };
}

export default useRfiNotifications;
